// Recovered compiled webpack factory 78041. Edit this function expression; run npm run build.
(t, e, i) => {
  (i.d(e, { $: () => n, V: () => s }), i(95704));
  let n = () => {},
    s = () => {};
}
